module.exports = __webpack_public_path__ + "static/fonts/Roboto-Medium.b2d307df.ttf";